/* eslint-disable */
import LogoutAPI from "../../Api/LogoutAPI";
import {
  clearRedux,
  checkLogin,
  SelectMainNavigation,
} from "../../redux/actions/adminActions";

const CommonLogout = async (accessToken, dispatch) => {
  console.log("inide common logout");
  if (accessToken !== "" && accessToken !== null) {
    console.log("inide common logout 1");

    const responce = await LogoutAPI(accessToken);
    if (responce?.status === 200) {
      console.log("inide common logout 1.1");

      setTimeout(() => {
        window.location.replace(
          process.env.REACT_APP_BASE_URL + `user/del_login/${location?.host}`,
        );
        dispatch(clearRedux());
        localStorage.clear();
        dispatch(checkLogin("no"));
        dispatch(SelectMainNavigation("Dashboard"));
        localStorage.removeItem("access_token");
      }, 200);
    } else {
      console.log("inide common logout 1.2");
      setTimeout(() => {
        dispatch(clearRedux());
        localStorage.clear();
        dispatch(checkLogin("no"));
        localStorage.removeItem("access_token");
      }, 200);
    }
  }
};

export default CommonLogout;
